import { Star } from "lucide-react";

const reviews = [
  { name: "Sara Al-Harbi", role: "CTO, Vaultline", body: "CoderLity rebuilt our fintech stack in 12 weeks. The team is fast, opinionated and obsessed with quality.", rating: 5 },
  { name: "Tanvir Hasan", role: "Founder, Orbital", body: "Easily the most full-stack agency we've ever hired. They handled product, infra and marketing under one roof.", rating: 5 },
  { name: "Maya Lin", role: "Head of Growth, Mosaic", body: "Revenue is up 3.2x since we moved SEO + ads to CoderLity. Their AI workflows are a real edge.", rating: 5 },
];

export function Testimonials() {
  return (
    <section className="py-24 bg-card/30 border-y border-border">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-xs font-semibold uppercase tracking-widest text-primary">Loved by founders</div>
          <h2 className="mt-3 text-3xl sm:text-5xl font-bold tracking-tight">What clients <span className="text-gradient">say about us</span></h2>
        </div>
        <div className="grid gap-5 md:grid-cols-3">
          {reviews.map((r) => (
            <div key={r.name} className="rounded-2xl border border-border bg-card p-6 shadow-card">
              <div className="flex gap-0.5">
                {[...Array(r.rating)].map((_, i) => <Star key={i} className="h-4 w-4 fill-primary text-primary" />)}
              </div>
              <p className="mt-4 text-sm leading-relaxed">"{r.body}"</p>
              <div className="mt-6 flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-gradient-brand" />
                <div>
                  <div className="text-sm font-semibold">{r.name}</div>
                  <div className="text-xs text-muted-foreground">{r.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
